<template>
    <div>
        <div class="header mb-2">{{ header }}</div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'FooterItem',
    props: {
        header: {
            type: String,
            default: () => '',
        },
    },
};
</script>

<style scoped>
.header {
    font-size: 0.8em;
}
</style>
